import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from './../auth/auth.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-addproject',
  templateUrl: './addproject.component.html',
  styleUrls: ['./addproject.component.css']
})
export class AddprojectComponent implements OnInit {

 
  hello = true;
  chekuser:any;
  emailid:any;
  sign = 'visibility_off';
  professions = [
    {value: 'Civil engineer', viewValue: 'Civil engineer'},
    {value: 'Architect', viewValue: 'Architect'},
    {value: 'Engineer', viewValue: 'Engineer'}
  ];
  constructor(
    private authService: AuthService,
    private router: Router,
    public snackBar: MatSnackBar
  ) { }
  addProject: FormGroup;
  regFormData: any;
  ngOnInit() {
    this.addProject = new FormGroup ({
      project: new FormControl('',Validators.required),
     
     
     
     
  })
  }

  onSubmitUser() {
    if (this.addProject.valid) {
      this.authService.addProject(this.addProject.value).subscribe( data => {
        
       this.snackBar.open('Project added successfully ', 'clear', {
        duration: 5000,
      });
        this.regFormData = data;
        this.addProject.reset();
        //this.router.navigate(['/logedin']);
        
       
      
      }) // {7}
     
    }
  }
  

}
